import { render, staticRenderFns } from "./openLaunchApp.vue?vue&type=template&id=12c2db9d&scoped=true&"
import script from "./openLaunchApp.vue?vue&type=script&lang=js&"
export * from "./openLaunchApp.vue?vue&type=script&lang=js&"
import style0 from "./openLaunchApp.vue?vue&type=style&index=0&id=12c2db9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2db9d",
  null
  
)

export default component.exports